import {
  params, string, bool, shape, arrayOf, extend, number
} from '@thd-nucleus/data-sources';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { ProductPod } from '../components/ProductPod';
import { WallPriceSummary } from '../components/Collections/CabinetSummary/WallPriceSummary';
import { WallDesigner } from '../components/Collections/CabinetVisualizer/WallDesigner/WallDesigner';

export const ProductDataModel = {
  product: params({ itemId: string().isRequired() }).shape({
    info: shape({
      dotComColorEligible: bool()
    }),
    identifiers: shape({
      skuClassification: string()
    })
  })
};

export const ClientOnlyProductDataModel = {
  clientOnlyProduct: params({ itemId: string().isRequired() }).shape({
    itemId: string(),
    dataSources: string(),
    info: shape({
      gccExperienceOmsId: string(),
      recommendationFlags: shape({
        visualNavigation: bool(),
        pipCollections: bool(),
        ACC: bool()
      }),
      dotComColorEligible: bool()
    }),
    identifiers: shape({
      productType: string(),
      skuClassification: string()
    }),
    seoDescription: string()
  }),
};

export const ChoicesDataModel = {
  products: params({ itemIds: arrayOf(string().isRequired()).isRequired() }).shape({
    itemId: string(),
    dataSources: string(),
    info: shape({
      gccExperienceOmsId: string(),
      recommendationFlags: shape({
        visualNavigation: bool(),
        pipCollections: bool(),
        ACC: bool()
      }),
      dotComColorEligible: bool()
    }),
    identifiers: shape({
      productType: string(),
      skuClassification: string()
    }),
    seoDescription: string()
  }),
};

const product = {

  product: params({ itemId: string().isRequired(), dataSource: string() }).shape({
    itemId: string(),
    dataSources: string(),
    details: shape({
      description: string(),
      descriptiveAttributes: arrayOf(shape({
        name: string(),
        value: string(),
        bulleted: string(),
        sequence: number()
      })),
      highlights: arrayOf(string()),
    }),
    identifiers: shape({
      brandName: string(),
      productLabel: string(),
      brandMainPageUrl: string(),
      modelNumber: string(),
      rentalCategory: string(),
      rentalSubCategory: string(),
      storeSkuNumber: string(),
      upc: string()
    }),

  })
};

const Collection = {
  searchModel: params({
    itemIds: arrayOf(string()).isRequired(),
    storeId: string().isRequired()
  }).shape({
    products: arrayOf(shape({
      info: shape({
        categoryHierarchy: arrayOf(string())
      }),
      ...ProductPod.dataModel.product
    }))
  }),
};

export const DesignCollection = extend(
  WallDesigner,
  WallPriceSummary,
  Breadcrumbs,
  {
    searchModel: params({
      itemIds: arrayOf(string()).isRequired(),
      storeId: string().isRequired()
    }).shape({
      products: arrayOf(shape({
        info: shape({
          categoryHierarchy: arrayOf(string())
        }),
        ...WallPriceSummary.dataModel.product
      }))
    })
  },
  {
    product: params({ itemId: string().isRequired(), dataSource: string() }).shape({
      itemId: string(),
      dataSources: string(),
      details: shape({
        description: string(),
        descriptiveAttributes: arrayOf(shape({
          name: string(),
          value: string(),
          bulleted: string(),
          sequence: number()
        })),
        highlights: arrayOf(string()),
      }),
      identifiers: shape({
        brandName: string(),
        productLabel: string(),
        brandMainPageUrl: string(),
        modelNumber: string(),
        rentalCategory: string(),
        rentalSubCategory: string(),
        storeSkuNumber: string(),
        upc: string()
      }),
    }),

  },
);

export const CollectionDataModel = extend(
  Breadcrumbs,
  ProductPod.dataModel,
  Collection
);

export const DesignDataModel = extend(
  Collection
);
